/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{
/**
  * @class HPGuage
  * @extends phina.ui.Gauge
  */
phina.define('HPGauge', {
  superClass: 'phina.ui.Gauge',

  init: function(options) {
    options = (options || {}).$safe({
      damageColor: '#f00',
    });
    this.damageColor = options.damageColor;

    this.superInit(options);
    this.text = phina.display.Label({
      text:this.value, stroke:'transparent', fill:'rgb(255,255,255)',
      fontSize: 20, strokeWidth: 5, align: 'right', fontWeight: 'bold',
    }).addChildTo(this)
    .setSize(this.width, this.height)
    .setPosition(this.width/2, 0);
  },

  setValue: function(value) {
    value = Math.clamp(value, 0, this.maxValue);

    // end when now value equal value of argument
    if (this.value === value) return ;

    // fire value change event
    this.flare('change');

    this.oldValue = this.oldValue || this._value;
    this._value = value;
    this.text.text = value;

    if (this.animation) {
      this.tweener.ontween = function() {
        this._dirtyDraw = true;
      }.bind(this);
      this.visualAlpha = 1.0;
      this.tweener.clear()
        .to({'visualAlpha': 1.0}, 1000) //TODO waitしたら緑バーが動かない
        .to({'visualAlpha': 0.0}, 1000)
        .call(function() {
          this.oldValue=0;
          this.flare('changed');
          if (this.isEmpty()) {
            this.flare('empty');
          }
          else if (this.isFull()) {
            this.flare('full');
          }
        }, this);
    } else {
      this.visualAlpha = 0.0;
      this.oldValue=0;
      this.flare('changed');
      if (this.isEmpty()) {
        this.flare('empty');
      }
      else if (this.isFull()) {
        this.flare('full');
      }
    }
  },

  getRate: function() {
    var rate = this.visualValue/this.maxValue;
    return rate;
  },

  prerender: function(canvas) {
    canvas.roundRect(-this.width/2, -this.height/2, this.width, this.height, this.cornerRadius);
  },

  postrender: function(canvas) {
    // var rate = this.getRate();
    canvas.context.save();
    // ダメージ前のゲージ
    canvas.context.fillStyle = this.damageColor;
    canvas.context.globalAlpha = this.visualAlpha;
    canvas.fillRect(-this.width/2, -this.height/2,
      this.width*this.oldValue/this.maxValue, this.height);

    // 実際の体力ゲージ
    canvas.context.fillStyle = this.gaugeColor;
    canvas.context.globalAlpha = 1.0;
    canvas.context.clip();
    canvas.fillRect(-this.width/2, -this.height/2,
       this.width*this.value/this.maxValue, this.height);
    canvas.context.restore();
  },

});

phina.define('HPGauge2', {
  superClass: 'phina.ui.Gauge',

  init: function(options) {
    options = (options || {}).$safe({
      damageColor: '#f00',
    });
    this.damageColor = options.damageColor;
    this.oldValue = 0;

    this.superInit(options);
    // 最初が0なら非表示
    this.text = phina.display.Label({
      text:this.value||'', stroke:'transparent', fill:'rgb(255,255,255)',
      fontSize: 20, strokeWidth: 5, align: 'right', fontWeight: 'bold',
    }).addChildTo(this)
    .setSize(this.width, this.height)
    .setPosition(this.width/2, 0);
  },

  setValue: function(value) {
    value = Math.clamp(value, 0, this.maxValue);

    // end when now value equal value of argument
    if (this.value === value) return ;

    // fire value change event
    this.flare('change');

    this._up = this._value < value;
    this.oldValue = this.oldValue || this._value || 0;
    this._value = value;
    if(this._up){
      //do nothing
    }else{
      this.text.text = value;
    }

    if (this.animation) {
      this.tweener.ontween = function() {
        this._dirtyDraw = true;
      }.bind(this);
      this.visualAlpha = 1.0;
      var l = this.gaugeColor.length;
      this.tweener.clear()
        .to({'visualValue': value}, Math.abs(value-this.oldValue)*l*1000/this.maxValue)
        .call(function(){ this.text.text = value }, this)
        .to({'visualAlpha': 0.0}, 1000)
        .call(function() {
          this.oldValue=0;
          this.flare('changed');
          if (this.isEmpty()) {
            this.flare('empty');
          }
          else if (this.isFull()) {
            this.flare('full');
          }
        }, this);
    } else {
      this.visualAlpha = 0.0;
      this.visualValue = value;
      this.oldValue=0;
      this.flare('changed');
      if (this.isEmpty()) {
        this.flare('empty');
      }
      else if (this.isFull()) {
        this.flare('full');
      }
    }
  },

  getRate: function() {
    var rate = this.visualValue/this.maxValue;
    return rate;
  },

  prerender: function(canvas) {
    canvas.roundRect(-this.width/2, -this.height/2, this.width, this.height, this.cornerRadius);
  },

  postrender: function(canvas) {
    // var rate = this.getRate();
    var l = this.gaugeColor.length;

    canvas.context.save();
    // ダメージ前のゲージ
    canvas.context.fillStyle = this.damageColor;
    canvas.context.globalAlpha = this.visualAlpha;
    canvas.fillRect(-this.width/2, -this.height/2,
      this.width*(this.oldValue.clamp(0,this.maxValue/l))/(this.maxValue/l), this.height);

    // 実際の体力ゲージ
    this.gaugeColor.map((v, i)=>{
      canvas.context.fillStyle = v;
      canvas.context.globalAlpha = 1.0;
      canvas.context.clip();
      if(this._up){
        canvas.fillRect(-this.width/2, -this.height/2+i*3,
          this.width*(this.visualValue-this.maxValue*i/l).clamp(0,this.maxValue/l)/(this.maxValue/l), this.height-i*3);
        this.text.text = Math.floor(this.visualValue);
      }else{
        canvas.fillRect(-this.width/2, -this.height/2+i*3,
          this.width*(this.value-this.maxValue*i/l).clamp(0,this.maxValue/l)/(this.maxValue/l), this.height-i*3);
      }
      canvas.context.restore();  
    });
  },

});


}